import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HeaderHeightService {
    private headerHeight: number;

    constructor(@Inject(DOCUMENT) private document: Document) {}

    get height(): number {
        return this.headerHeight;
    }

    update(contentElement: HTMLElement): void {
        this.headerHeight = Math.round(
            contentElement.getBoundingClientRect().top
        );

        const appContainer = this.document.querySelector(
            'div.cms-ride-command'
        ) as HTMLElement;

        if (appContainer) {
            appContainer.style.setProperty(
                '--header-height',
                `${this.headerHeight}px`
            );
        }
    }
}
